import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';

const InlineWrapperWithMarginPR = ({ children }) => (
  <span style={{ marginRight: '0.5rem' }}>{children}</span>
);

const ProductRecommendationsSkeletonCard = () => (
  <section className="col-md col-md-3">
    <div className="col-md ">
      <Skeleton duration={2} height={250} />
    </div>
    <div className="col-md">
      <Skeleton duration={2} />
    </div>
    <div className="col-md">
      <Skeleton duration={2} count={3} />
    </div>
    <div className="col-md">
      <Skeleton duration={2} height={60} />
    </div>
    <div className="col-md">
      <>
        <Skeleton duration={2} height={40} inline width={50} wrapper={InlineWrapperWithMarginPR} />
        <Skeleton duration={2} height={40} inline width={140} wrapper={InlineWrapperWithMarginPR} />
      </>
    </div>
    <div className="col-md">
      <Skeleton duration={2} />
    </div>
  </section>
);

const ProductRecommendationsSkeletonEffect = () => (
  <>
    <div className="cmp-product-compare row">
      {ProductRecommendationsSkeletonCard()}
      {ProductRecommendationsSkeletonCard()}
      {ProductRecommendationsSkeletonCard()}
      {ProductRecommendationsSkeletonCard()}
    </div>
  </>
);

InlineWrapperWithMarginPR.propTypes = {
  children: PropTypes.string,
};

InlineWrapperWithMarginPR.defaultProps = {
  children: '',
};

export default ProductRecommendationsSkeletonEffect;
